import { DomainLevel } from "apps/platform-client/client/src/models/enums/enums";
import DropDownButton, { IDropDownButtonMenuOption } from "../../../../../components/DropDownButton";
import { useTranslation } from "react-i18next";

interface ISwitchButtonProps {
	siblingDomains: Array<{ id: string; name: string }>;
	domainLevel?: number;
}

export const SwitchButton = (props: ISwitchButtonProps) => {
	const { t } = useTranslation();
	const defaultText = props.domainLevel === DomainLevel.PRODUCT ? "domain-switch-product" : "domain-switch-subdomain";

	const menuItems: Array<IDropDownButtonMenuOption> = props.siblingDomains.map((domain) => ({
		id: domain.id,
		label: domain.name,
		link: `/organization-settings/domains/${domain.id}`,
	}));

	return (
		<DropDownButton
			variant="outlined"
			color="primary"
			defaultText={t(defaultText)}
			isDisabled={!menuItems.length}
			menuOptions={menuItems}
		/>
	);
};
